class FFHamburger {
  DOM: {
    underlay: HTMLElement | null
    toggle: HTMLElement | null
    menu: HTMLElement | null
  }

	constructor(){
		this.DOM = {
			underlay: document.querySelector('#ff-underlay-main'),
			toggle: document.querySelector('#ff-icon-mobile-menu'),
			menu: document.querySelector('#ff-nav-main-mobile'),
		}
		this.events();
	}

	events(){
		this.DOM.toggle?.addEventListener('click', this.toggle.bind(this) );
		this.DOM.underlay?.addEventListener('click', this.close.bind(this) );
	}

	toggle(){
		if( this.DOM.toggle?.classList.contains('ff-active') ){
			this.close();
		}else{
			this.open();
		}
	}

	open(){
		this.DOM.toggle?.classList.add('ff-active');
		this.DOM.menu?.classList.add('ff-active');
		this.DOM.underlay?.classList.add('ff-active');
	}

	close(){
		this.DOM.toggle?.classList.remove('ff-active');
		this.DOM.menu?.classList.remove('ff-active');
		this.DOM.underlay?.classList.remove('ff-active');
	}

};
new FFHamburger();